import React from "react";

export default function FAQ() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-center mb-8 text-purple-600">
        Frequently Asked Questions
      </h1>

      <div className="space-y-4">
        <details className="bg-gray-800 rounded-xl p-4">
          <summary className="font-semibold cursor-pointer text-white">
            💰 What is MediCoin?
          </summary>
          <p className="text-gray-300 mt-2">
            MediCoin (MCN) is the utility token powering the MediCureOn ecosystem, enabling payments, discounts, staking, and access to health-related services across traditional and alternative healthcare.
          </p>
        </details>

        <details className="bg-gray-800 rounded-xl p-4">
          <summary className="font-semibold cursor-pointer text-white">
            🚀 How can I participate in the ICO?
          </summary>
          <p className="text-gray-300 mt-2">
            Visit the presale page and connect your wallet. You can purchase MCN using ETH, USDT, or USDC. The token price and remaining time for each sale phase are displayed in real-time.
          </p>
        </details>

        <details className="bg-gray-800 rounded-xl p-4">
          <summary className="font-semibold cursor-pointer text-white">
            🔒 What is the vesting and locking period?
          </summary>
          <p className="text-gray-300 mt-2">
            Seed, Private, and Public sales have an initial lock period followed by linear vesting. You’ll be able to claim tokens as they unlock. The exact vesting schedule is shown in the Claim Portal.
          </p>
        </details>

        <details className="bg-gray-800 rounded-xl p-4">
          <summary className="font-semibold cursor-pointer text-white">
            📉 Will MediCoin be burned?
          </summary>
          <p className="text-gray-300 mt-2">
            Yes, 30% of the total supply will be gradually burned over the next 3 years to ensure long-term value by reducing supply as demand increases.
          </p>
        </details>

        <details className="bg-gray-800 rounded-xl p-4">
          <summary className="font-semibold cursor-pointer text-white">
            🤝 Can I stake my MCN tokens?
          </summary>
          <p className="text-gray-300 mt-2">
            Yes! You’ll be able to stake your MCN to earn rewards. Staking pools and APR details will be shared post-ICO.
          </p>
        </details>

        <details className="bg-gray-800 rounded-xl p-4">
          <summary className="font-semibold cursor-pointer text-white">
            🌐 What is MediCureOn?
          </summary>
          <p className="text-gray-300 mt-2">
            MediCureOn is a decentralized health platform combining AI, blockchain, and IoMT devices to offer personalized care by integrating both traditional and alternative healthcare.
          </p>
        </details>
      </div>
    </div>
  );
}
